import cls from "classnames";
import { ReactNode } from "react";
import styles from "./index.module.scss";

type Props = {
  // Point the control's aria-describedby at this to have it announced with the field.
  id?: string;
  className?: string;
  children: ReactNode;
};

/**
 * The error belonging to one form control. Carries no ARIA role of its own: a
 * field references it through `aria-describedby`, so announcing it again on
 * appearance would repeat it.
 *
 * For a failure that belongs to a form, a panel or a page rather than to a single
 * control, reach for `ErrorBanner` — it announces itself and can carry an action.
 */
export default function FieldError(props: Props) {
  return (
    <span id={props.id} className={cls(styles.error, props.className)}>
      {props.children}
    </span>
  );
}
